// src/@vxapp/Enums/Cookie.ts

/** vxapp cookies */
export enum Cookie {
  // Slave PHP
  PhpApi = 'vxapp_slave_api_guid',

  // AuthStore
  Headers = 'vxapp_stores_auth_headers',
  Token = 'vxapp_stores_auth_token',
  Api = 'vxapp_stores_api_guid',
  Role = 'vxapp_stores_auth_roleGUID',
  UserData = 'vxapp_stores_auth_userData',
  UserPreferences = 'vxapp_stores_auth_userPreferences',
  Permissions = 'vxapp_stores_auth_permissions',
  PageMeta = 'vxapp_stores_page_meta',
  SessionEndNotice = 'vxapp_stores_auth_session_end_notice',
  MatchedPermission = 'vxapp_stores_auth_matched_permission',
  RefreshInProg = 'vxapp_stores_auth_token_refresh_in_prog',

  // Booleans
  AuthStatus = 'vxapp_stores_auth_state',
  Authenticated = 'vxapp_stores_auth_is_authenticated',
  User = 'vxapp_stores_auth_is_user',
  Guest = 'vxapp_stores_auth_is_guest',
  Expired = 'vxapp_stores_auth_is_expired',
  RenewAllowed = 'vxapp_stores_auth_is_renew_allowed',

  // Maintenance
  MaintenanceMode = 'vxapp_slave_maintenance_status',
  MaintenanceMessage = 'vxapp_slave_maintenance_message',

  // Theme
  ThemeConfig = 'vxapp_vue_theme_config',
  ColorScheme = 'vxapp_theme_user_system_preference', // dark:light
  Theme = 'vxapp_theme_current_mode',

  // Slave
  LastProductGuid = 'vxapp_slave_last_product_guid',

  // Google Places AutoComplete
  LastAddressValidated = 'vxapp_lastAddressValidated',
  GoogleSettings = 'vxapp_googleSettings_', // addressInputId

  // Local Storage
  StoreProduct = 'vxapp_product_', // productGUID

  // Flatpickr
  LastInstallDate = 'vxapp_lastInstallDate',
  LightThemePrimaryColor = 'vxapp_theme_light_primary_color',
  DarkThemePrimaryColor = 'vxapp_theme_dark_primary_color',
  LightThemePrimaryDarkenColor = 'vxapp_theme_light_primary_darken_color',
  DarkThemePrimaryDarkenColor = 'vxapp_theme_dark_primary_darken_color',

  // Slave Frontend - Guest Authentication
  GuestToken = 'vxapp_guest_token',
  ApiGuid = 'vxapp_api_guid',

  // Slave Frontend - User Preferences
  SelectedDate = 'vxapp_selected_date',
  SelectedProduct = 'vxapp_selected_product',

  // Slave Frontend - Service Area
  ServiceAreaPostcode = 'vxapp_service_area_postcode',
  ServiceAreaSuburb = 'vxapp_service_area_suburb',
  ServiceAreaState = 'vxapp_service_area_state',
  ServiceAreaAddress = 'vxapp_service_area_address',
  ServiceAreaValid = 'vxapp_service_area_valid',

  // Slave Frontend - Cart/Order
  CartItems = 'vxapp_cart_items',
  OrderTemplateGuid = 'vxapp_order_template_guid',

  // Slave Frontend - Session
  SessionId = 'vxapp_session_id',
  LastActivity = 'vxapp_last_activity',
}
